import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { option_type, class_type, record_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { TranslationPages_Home__get_Close, TranslationPages_Home__get_Warning, TranslationPages_Home__get_Cancel, AppTranslations__get_Home, TranslationPages_Home__get_Confirmation } from "../Shopfoo.Shared/Translations.js";
import { createElement } from "react";
import React from "react";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";

export class DialogTranslations extends Record {
    constructor(Title, Message, Close) {
        super();
        this.Title = Title;
        this.Message = Message;
        this.Close = Close;
    }
}

export function DialogTranslations_$reflection() {
    return record_type("Shopfoo.Client.Components.Dialog.DialogTranslations", [], DialogTranslations, () => [["Title", string_type], ["Message", string_type], ["Close", string_type]]);
}

export class DialogProps extends Record {
    constructor(Translations, MainButton) {
        super();
        this.Translations = Translations;
        this.MainButton = MainButton;
    }
}

export function DialogProps_$reflection() {
    return record_type("Shopfoo.Client.Components.Dialog.DialogProps", [], DialogProps, () => [["Translations", DialogTranslations_$reflection()], ["MainButton", option_type(class_type("Fable.React.ReactElement", undefined))]]);
}

export function DialogProps_get_Empty() {
    return new DialogProps(new DialogTranslations("", "", ""), undefined);
}

export function DialogProps_Confirmation_FE1BE0D(translations, question, button) {
    return new DialogProps(new DialogTranslations(TranslationPages_Home__get_Confirmation(AppTranslations__get_Home(translations)), question, TranslationPages_Home__get_Cancel(AppTranslations__get_Home(translations))), button);
}

export function DialogProps_Warning_8DF871A(translations, message) {
    return new DialogProps(new DialogTranslations(TranslationPages_Home__get_Warning(AppTranslations__get_Home(translations)), message, TranslationPages_Home__get_Close(AppTranslations__get_Home(translations))), undefined);
}

export function ModalDialog(modalDialogInputProps) {
    let elems_2, elems_1, elems;
    const closeModal = modalDialogInputProps.closeModal;
    const props = modalDialogInputProps.props;
    const ref = modalDialogInputProps.ref;
    const key = modalDialogInputProps.$key;
    return createElement("dialog", createObj(Helpers_combineClasses("modal", ofArray([["key", `${key}-dialog`], ["ref", ref], (elems_2 = [createElement("div", createObj(Helpers_combineClasses("modal-box", ofArray([["key", `${key}-dialog-box`], (elems_1 = [createElement("form", {
        key: `${key}-dialog-form`,
        children: createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-sm"], ["className", "btn-circle"], ["className", "btn-ghost"], ["className", "absolute right-2 top-2"], ["children", "✕"], ["onClick", closeModal]])))),
    }), createElement("h3", {
        key: `${key}-dialog-title`,
        className: "font-bold text-lg",
        children: props.Translations.Title,
    }), createElement("p", {
        key: `${key}-dialog-message`,
        className: "py-4",
        children: props.Translations.Message,
    }), createElement("div", createObj(Helpers_combineClasses("modal-action", ofArray([["key", `${key}-dialog-actions`], (elems = toList(delay(() => append(singleton(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-secondary"], ["className", "btn-outline"], ["key", `${key}-dialog-cancel-button`], ["children", props.Translations.Close], ["onClick", closeModal]]))))), delay(() => {
        const matchValue = props.MainButton;
        if (matchValue != null) {
            return singleton(matchValue);
        }
        else {
            return empty();
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), createElement("label", createObj(Helpers_combineClasses("modal-backdrop", ofArray([["key", `${key}-dialog-backdrop`], ["onClick", closeModal]]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
}

